import React from "react";
import { useTranslation } from "react-i18next";
import CustomModal from "./CustomModal";
import { useRegistrationPrompt } from "../../context/RegistrationPromptContext";
import { useGlobalModal } from "../../context/ModalContext";
import { Link } from "react-router-dom";
import { CANONICAL_SALES_PATH } from "../../constants/salesRoutes";

const RegistrationPrompt = () => {
  const { t } = useTranslation();
  const { showPrompt, dismissPrompt } = useRegistrationPrompt();
  const { openModal } = useGlobalModal();

  if (!showPrompt) return null;

  const handleSubscribe = () => {
    dismissPrompt();
  };

  const handleLogin = () => {
    dismissPrompt();
    openModal("login");
  };

  return (
    <CustomModal
      show={showPrompt}
      hideModal={dismissPrompt}
      classValue="login-modal-main-container"
      centered
      size="lg"
    >
      <div className="login-modal-holder">
        <div className="login-modal-title">
          <h1>{t("registrationPrompt.title")}</h1>
          <div className="login-modal-close-icon" onClick={dismissPrompt}>
            <img src="/images/close.png" alt="close" className="img-fluid" />
          </div>
        </div>

        <div className="login-modal-container">
          <div className="login-modal-form">
            <div className="info-login-subtitle">
              {t("registrationPrompt.subtitle")}
            </div>

            <div className="info-login-buttons">
              <Link to={CANONICAL_SALES_PATH} onClick={handleSubscribe}>
                {t("registrationPrompt.register")}
              </Link>
              <button className="secondary" onClick={handleLogin}>
                {t("registrationPrompt.login")}
              </button>
            </div>
          </div>

          <div className="login-modal-banner">
            <img src="/images/logo-login-kat.png" alt="" className="img-fluid" />
          </div>
        </div>
      </div>
    </CustomModal>
  );
};

export default RegistrationPrompt;
